export default __webpack_public_path__ + "static/media/img-guide-gt-popup-2-de_de.6a497154.png";